import { login } from "@services/account/auth";
import router from "@router";
import i18n from "@/i18n";
import posthog from "posthog-js";

const state = {
    btnLoading: false
};

const actions = {
    loginAction({ commit }, params) {
        commit("UPDATE_BTN_LOADING", true);
        login(params)
            .then((res) => {
                const data = res.data;
                localStorage.setItem(
                    "permission",
                    JSON.stringify(data.permission)
                );
                localStorage.setItem("displayName", data.username);
                localStorage.setItem("user_id", data.id);
                localStorage.setItem("homeId", data.home_page_profile_id);
                localStorage.setItem("alertId", data.alert_page_profile_id);
                localStorage.setItem(
                    "tutorial_presented",
                    data.tutorial_presented
                );
                // 存储 email 用于后续需要（如 redirectToRH）
                if (params.email) {
                    localStorage.setItem("userEmail", params.email);
                }

                posthog.identify(String(data.id), {
                    email: params.email,
                    username: data.username
                });
                posthog.capture("user_logged_in", {
                    username: data.username
                });

                const snackbar = {
                    message: i18n.t("security.loginSuccess"),
                    color: "green",
                    btnName: "Close",
                    status: true,
                    timeout: 2000
                };
                commit("UPDATE_SNACKBAR", snackbar, { root: true });

                setTimeout(() => {
                    router.push({ name: "Home" });
                    commit("UPDATE_BTN_LOADING", false);
                }, 1000);
            })
            .catch((e) => {
                posthog.capture("user_login_failed", {
                    error_status: e?.response?.status
                });
                if (e?.response?.status == 401) {
                    commit("UPDATE_BTN_LOADING", false);
                }
                if (e?.response?.status == 422) {
                    const snackbar = {
                        message: e.response.data.msg,
                        color: "red",
                        btnName: "Close",
                        status: true,
                        timeout: 2500
                    };
                    commit("UPDATE_SNACKBAR", snackbar, { root: true });
                    commit("UPDATE_BTN_LOADING", false);
                }
                if (!e?.response?.status) {
                    const snackbar = {
                        message:
                            "Unable to resolve the request, please try again later",
                        color: "red",
                        btnName: "Close",
                        status: true,
                        timeout: 2500
                    };
                    commit("UPDATE_SNACKBAR", snackbar, { root: true });
                    commit("UPDATE_BTN_LOADING", false);
                }
            });
    }
};

const mutations = {
    UPDATE_BTN_LOADING(state, data) {
        state.btnLoading = data;
    }
};

export default {
    namespaced: true,
    state,
    actions,
    mutations
};
